"use client";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VideoLibrarySharpIcon from "@mui/icons-material/VideoLibrarySharp";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import "../style/Optioncard.css";

const Optioncard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const item = location.state?.item || null;
const category = location.state?.category || null;
  return (
    <div className="optioncard-container">
      <h2 className="optioncard-heading">Choose an Option</h2>

      <div className="optioncard-grid">
        {/* Watch Video Card */}
        <div
          className="optioncard-item"
       onClick={() => navigate("/AIandDigital", { state: { category } })}
        >
          <div className="optioncard-icon video-icon">
            <VideoLibrarySharpIcon style={{ fontSize: 60 }} />
          </div>
          <h3>Watch Video</h3>
          <p>Explore AI & Digital video content</p>
        </div>
        <div
          className="optioncard-item"
          onClick={() =>
            navigate("/library", {
              state: { openSummary: true, item, category },
            })
          }
        >
          <div className="optioncard-icon summary-icon">
            <LibraryBooksIcon style={{ fontSize: 60 }} />
          </div>
          <h3>Read Summary</h3>
          <p>Open AI & Digital summary article</p>
        </div>
      </div>
    </div>
  );
};

export default Optioncard;
